export const NUMBER_INPUT_PARTS = [
  'root',
  'field',
  'stepper',
  'stepperGroup',
] as const;
